import { useEffect } from "react";

export default function Photos() {
  useEffect(() => {
    // Load Flickr embed script
    const script = document.createElement("script");
    script.src = "//embedr.flickr.com/assets/client-code.js";
    script.async = true;
    script.charset = "utf-8";
    document.body.appendChild(script);
    return () => document.body.removeChild(script);
  }, []);

  return (
    <section id="slideshow">
      <div className="section-inner">
        <div className="section-eyebrow">Gallery</div>
        <div className="section-title">Photos &amp; Highlights</div>
        <div className="section-divider"></div>
        <div style={{ maxWidth: "640px", margin: "0 auto" }}>
          <a
            data-flickr-embed="true"
            href="https://www.flickr.com/photos/204499850@N06/albums/72177720333124514"
            title="webpage"
          >
            <img
              src="https://live.staticflickr.com/65535/55208606458_1a084d3127_z.jpg"
              width="640"
              height="480"
              alt="Knights of the Ping Pong Table photos"
              style={{ width: "100%", height: "auto" }}
            />
          </a>
        </div>
      </div>
    </section>
  );
}
